<template>
    <div class="login-container">
        <!-- <video autoplay muted loop="loop" class="bg-video">
            <source
                src="https://longfei-chezhu.oss-cn-beijing.aliyuncs.com/xcx/index.mp4"
                type="video/mp4"
            />
        </video> -->
        <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            autocomplete="on"
            label-position="left"
        >
            <div class="title-container">
                <h3 class="title">出单后台登录</h3>
            </div>

            <el-form-item prop="username">
                <span class="svg-container">
                    <svg-icon icon-class="user" />
                </span>
                <el-input
                    ref="username"
                    v-model="loginForm.username"
                    placeholder="用户名称"
                    name="username"
                    type="text"
                    tabindex="1"
                    autocomplete="on"
                />
            </el-form-item>

            <el-form-item prop="password">
                <span class="svg-container">
                    <svg-icon icon-class="password" />
                </span>
                <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="用户密码"
                    name="password"
                    tabindex="2"
                    autocomplete="on"
                    @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd" @click="showPwd">
                    <svg-icon
                        :icon-class="
                            passwordType === 'password' ? 'eye' : 'eye-open'
                        "
                    />
                </span>
            </el-form-item>

            <!-- <el-form-item prop="code">
                <span class="svg-container">
                    <svg-icon icon-class="message" />
                </span>
                <el-input
                    ref="code"
                    v-model="loginForm.code"
                    type="text"
                    placeholder="验证码"
                    name="code"
                    tabindex="3"
                    autocomplete="ff"
                />
                <span class="code-img">
                    <img @click="updatecode" :src="img" />
                </span>
            </el-form-item> -->

            <el-button
                class="login-btn"
                :loading="loading"
                type="primary"
                style="width: 100%; margin-bottom: 30px"
                @click.native.prevent="handleLogin"
                >登录</el-button
            >
        </el-form>
    </div>
</template>

<script>
import { validUsername, validPassword } from "@/utils/validate";
import { Loading } from "element-ui";
import { captcha } from "@/api/user";

let loadingInstance = Loading.service();

export default {
    name: "Login",
    components: {},
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!validUsername(value)) {
                callback(
                    new Error(
                        "用户名称必须是字母、数字、下划线组合，且长度6-12位"
                    )
                );
            } else {
                callback();
            }
        };
        const validatePassword = (rule, value, callback) => {
            if (!validPassword(value)) {
                callback(
                    new Error(
                        "用户密码必须是字母、数字、下划线组合，且长度6-18位"
                    )
                );
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                username: "",
                password: "",
                code: "",
                key: "",
            },
            loginRules: {
                username: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: validateUsername,
                    },
                ],
                password: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: validatePassword,
                    },
                ],
                //code: [{ required: true, message: '验证码必填' ,trigger: "blur" }],
            },
            passwordType: "password",
            loading: false,
            redirect: undefined,
            otherQuery: {},
            img: "",
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                const query = route.query;
                if (query) {
                    this.redirect = query.redirect;
                    this.otherQuery = this.getOtherQuery(query);
                }
            },
            immediate: true,
        },
    },
    created() {
        loadingInstance.close();
        //this.getCaptcha();
    },
    mounted() {
        if (this.loginForm.username === "") {
            this.$refs.username.focus();
        } else if (this.loginForm.password === "") {
            this.$refs.password.focus();
        }
    },
    destroyed() {},
    methods: {
        getCaptcha() {
            captcha().then((response) => {
                this.img = response.data.img;
                this.loginForm.key = response.data.key;
                
            });
        },
        showPwd() {
            if (this.passwordType === "password") {
                this.passwordType = "";
            } else {
                this.passwordType = "password";
            }
            this.$nextTick(() => {
                this.$refs.password.focus();
            });
        },
        updatecode() {
            this.getCaptcha();
        },
        handleLogin() {
            var _this = this;
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$store
                        .dispatch("user/login", this.loginForm)
                        .then(() => {
                            this.$router.push({
                                path: _this.redirect || "/",
                                query: _this.otherQuery,
                            });
                            _this.loading = false;
                        })
                        .catch(() => {
                            _this.loading = false;
                        });
                } else {
                    console.log("请输入正确的账号和密码");
                    return false;
                }
            });
        },
        getOtherQuery(query) {
            return Object.keys(query).reduce((acc, cur) => {
                if (cur !== "redirect") {
                    acc[cur] = query[cur];
                }
                return acc;
            }, {});
        },
    },
};
</script>

<style lang="scss">
$bg: #fff;
// $light_gray: #EE6127;
$light_gray: #002242;
// $cursor: #EE6127;
$cursor: #002242;

.bg-video {
    width: 100vw;
    height: 100vh;
}
@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
        color: $cursor;
    }
}

/* reset element-ui css */
.login-container {
    .el-input {
        display: inline-block;
        height: 47px;
        width: 85%;

        input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            color: $light_gray;
            height: 47px;
            caret-color: $cursor;

            &:-webkit-autofill {
                box-shadow: 0 0 0px 1000px $bg inset !important;
                -webkit-text-fill-color: $cursor !important;
            }
        }
    }

    .el-form-item {
        // border: 1px solid #EE6127;
        border: 1px solid #002242;
        background: #fff;
        border-radius: 5px;
        // color: #EE6127;
        color: #002242;
    }
}
</style>

<style lang="scss" scoped>
// $bg: #EE6127;
$bg: #002242;
// $dark_gray: #EE6127;
$dark_gray: #002242;
$light_gray: red;

.login-container {
    min-height: 100%;
    width: 100%;
    background-color: $bg;
    overflow: hidden;

    .login-form {
        // position: fixed;
        // width: 520px;
        // max-width: 100%;
        // padding: 34px 35px 0;
        // margin: 0 auto;
        // overflow: hidden;
        // background-color: #fff;
        // top: 50%;
        // right: 5%;
        // transform: translateY(-50%);
        // border-radius: 17px;

        position: fixed;
        width: 520px;
        max-width: 100%;
        padding: 34px 35px 0;
        overflow: hidden;
        background-color: #fff;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        border-radius: 17px;
    }
    .login-btn {
        padding: 15px 15px;
    }

    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 10px;

        span {
            &:first-of-type {
                margin-right: 16px;
            }
        }
    }

    .svg-container {
        padding: 6px 5px 6px 15px;
        color: $dark_gray;
        vertical-align: middle;
        width: 30px;
        display: inline-block;
    }

    .title-container {
        position: relative;

        .title {
            font-size: 26px;
            // color: #EE6127;
            color: #002242;
            margin: 0px auto 40px auto;
            text-align: center;
            font-weight: bold;
            // text-shadow: 0 5px 5px #EE6127;
        }
    }

    .show-pwd {
        position: absolute;
        right: 10px;
        top: 7px;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
        user-select: none;
    }

    .code-img {
        position: absolute;
        right: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
        height: 47px;
    }
    .code-img img {
        height: 47px;
    }
    .thirdparty-button {
        position: absolute;
        right: 0;
        bottom: 6px;
    }

    @media only screen and (max-width: 470px) {
        .thirdparty-button {
            display: none;
        }
    }
}
</style>
